import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api'; // Ajusta la URL según tu configuración

export interface ItinerarioDia {
  dia: number;
  lugares: Lugar[];
  descripcion?: string;
}

export type ModoTransporte = 'andando' | 'bici' | 'coche';

export interface Lugar {
  id: number;
  nombre: string;
  tipo: string;
  descripcion?: string;
  latitud: number;
  longitud: number;
  icon?: string | null;
  // Propiedades opcionales
  score?: number;
  tiempoVisita?: number;
  horaLlegada?: string;
  horaSalida?: string;
  horario?: string;
  fotos?: string | string[] | null;
}

export interface PlannerContentOption {
  id: string;
  label: string;
  img: string;
  description?: string;
}

export interface PlannerContent {
  comoViajas: PlannerContentOption[];
  apetece: PlannerContentOption[];
}

export const obtenerContenidoPlanificador = async (): Promise<PlannerContent> => {
  const response = await axios.get(`${API_URL}/planner-content`);
  return {
    comoViajas: Array.isArray(response.data?.comoViajas) ? response.data.comoViajas : [],
    apetece: Array.isArray(response.data?.apetece) ? response.data.apetece : [],
  };
};

export const obtenerItinerario = async (
  perfil: string,
  dias: number,
  modoTransporte: ModoTransporte = 'coche',
): Promise<ItinerarioDia[]> => {
  try {
    const response = await axios.post(`${API_URL}/itinerary`, { perfil, dias, modoTransporte });
    console.log('Respuesta de obtenerItinerario:', response.data); // Log de la respuesta
    if (!Array.isArray(response.data)) {
      throw new Error(response.data?.message || response.data?.error || 'La API no devolvio un itinerario valido.');
    }
    return response.data;
  } catch (error) {
    console.error('Error al obtener el itinerario:', error);
    throw error;
  }
};





export const obtenerPuntosTuristicos = async (): Promise<Lugar[]> => {
  try {
    const response = await axios.get(`${API_URL}/puntos-turisticos`);
    console.log('Respuesta de obtenerPuntosTuristicos:', response.data); // Log de la respuesta
    return response.data;
  } catch (error) {
    console.error('Error al obtener los puntos turísticos:', error);
    throw error;
  }
};




// FUNCIÓN PARA RECALCULAR EL ITINERARIO

export const recalcularItinerario = async (
  dia: number,
  lugares: Lugar[],
  eliminar: Lugar | null,
  añadir: Lugar | null,
  modoTransporte: ModoTransporte = 'coche',
  horaInicio?: string,
): Promise<ItinerarioDia> => {
  try {
    const url = `${API_URL}/route/recalculate`;
    console.log('URL para recalcularItinerario:', url); // Agregar este log
    const response = await axios.post(url, { dia, lugares, eliminar, añadir, modoTransporte, horaInicio });
    console.log('Respuesta de recalcularItinerario:', response.data); // Log de la respuesta
    return response.data;
  } catch (error) {
    console.error('Error al recalcular el itinerario:', error);
    throw error;
  }
};







export const obtenerDescripcionRuta = async (lugares: Lugar[]): Promise<string> => {
  try {
    const response = await axios.post(`${API_URL}/descripcion`, { lugares });
    console.log('Respuesta de obtenerDescripcionRuta:', response.data);
    return response.data.descripcion;
  } catch (error) {
    console.error('Error al obtener la descripción de la ruta:', error);
    throw error;
  }
};




export const eliminarLugarItinerario = async (dia: number, lugarId: number, lugares: Lugar[]): Promise<ItinerarioDia> => {
  try {
    const url = `${API_URL}/eliminar`;
    // Ahora enviamos los lugares como 'lugaresActuales' en el body
    const response = await axios.post(url, { dia, lugarId, lugaresActuales: lugares });
    console.log('Respuesta de eliminarLugarItinerario:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar el lugar del itinerario:', error);
    throw error;
  }
};







export const crearPOIEnSegundoPlano = async (
 
  Name: string,
  Type: string,
  Latitude: number,
  Longitude: number,
  description: string,
  horario?: string
): Promise<{ jobId: string }> => {
  try {
    // Llamamos a nuestro endpoint "POST /poi/create"
    const response = await axios.post(`${API_URL}/poi/create`, {
      
      Name,
      Type,
      Latitude,
      Longitude,
      description,
      horario,
    });
    console.log('Respuesta de crearPOIEnSegundoPlano:', response.data); 
    // Se espera que la respuesta sea algo como: { jobId: "12345" }
    return response.data; // { jobId: string }
  } catch (error) {
    console.error('Error al crear el POI en segundo plano:', error);
    throw error;
  }
};

// 2) Obtener el estado del job
//    Llama a GET /poi/status/:jobId para saber si el job está completed, failed, etc.
export const obtenerEstadoCreacionPOI = async (jobId: string): Promise<string> => {
  try {
    // Llamamos a nuestro endpoint GET /poi/status/:jobId
    const response = await axios.get(`${API_URL}/poi/status/${jobId}`);
    console.log('Respuesta de obtenerEstadoCreacionPOI:', response.data);
    // La respuesta tendrá { status: 'waiting'|'active'|'completed'|'failed'|... }
    return response.data.status;
  } catch (error) {
    console.error('Error al obtener el estado de la creación del POI:', error);
    throw error;
  }
};



export const eliminarPOIPorNombre = async (name: string): Promise<string> => {
  try {
    const response = await axios.delete(`${API_URL}/poi/${name}`);
    // Suponiendo que el backend retorna { message: "..."}
    return response.data.message;
  } catch (error: any) {
    // Si no se encontró, puede venir un 404, lo manejas
    if (error.response && error.response.status === 404) {
      throw new Error(`No se encontró el POI con nombre "${name}"`);
    }
    throw new Error(error.response?.data?.message || 'Error al eliminar el POI');
  }
};



export const shareItinerary = async (payload: {
  email?    : string;           /* destino opcional */
  itinerary : ItinerarioDia[];  /* JSON completo  */
  name?     : string;           /* opcional       */
  note?     : string;           /* nota opcional  */
}) => {
  const { data } = await axios.post(`${API_URL}/share`, payload);
  return data;                  /* { token, url } */
};


export const obtenerItinerarioCompartido = async (
  token: string,
): Promise<ItinerarioDia[]> => {
  const { data } = await axios.get(`${API_URL}/share/${token}`);
  if (!Array.isArray(data)) {
    throw new Error(data?.message || data?.error || 'La API no devolvio un itinerario compartido valido.');
  }
  return data;          // array de días
};
